module.exports = {"TXTCLI_Number":{"id":"TXTCLI_Number","defaultMessage":"Szám","track":"Number"}}